"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.En = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var En = function En(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.2h15.865v9.6H0V3.2z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "EN_svg__a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 16,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.2h15.865v9.6H0V3.2z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#EN_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.6 4.274V3.2H.53l7.401 3.727L5.801 8-1.6 4.274zm9.532 4.8L.532 12.8H-1.6v-1.073L5.8 8l2.131 1.073zm0 0L10.064 8l7.401 3.727V12.8h-2.131L7.932 9.073zM10.064 8L7.932 6.927 15.334 3.2h2.131v1.073L10.064 8z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.344 6.4V3.2H9.52v3.2h7.944v3.2H9.521v3.2H6.344V9.6H-1.6V6.4h7.944z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98 7.04V3.2h1.906v3.84h8.58v1.92h-8.58v3.84H6.979V8.96H-1.6V7.04h8.58zM-1.6 12.8l6.355-3.2h1.421l-6.355 3.2H-1.6zm6.355-6.4L-1.6 3.2v.716L3.334 6.4h1.421zm4.934 0l6.355-3.2h1.421L11.11 6.4H9.689zm1.421 3.2l6.355 3.2v-.715L12.531 9.6H11.11z",
    fill: "#C00"
  })));
};

exports.En = En;
var _default = En;
exports.default = _default;